import classNames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ExpandedFundList from 'src/components/Buy/BuyFlow/ExpandedFundList/ExpandedFundList';
import { Fund } from 'src/components/Exchange/types';
import StepExpanded from 'src/components/Shared/StepExpanded/StepExpanded';
import {
  getAutoExchangeFromFundList,
  getAutoExchangeFromEditFund,
} from 'src/redux/modules/exchangeTransaction/autoExchangeTransaction.selectors';
import * as exchangeActions from 'src/redux/modules/exchangeTransaction/exchangeTransaction.module';
import { openModal } from 'src/redux/modules/modals/modals.module';
import { setShowAllFundsStep } from 'src/redux/modules/quickBuy/quickBuy.module';
import {
  getQuickBuyProductType,
  getUserFundList,
} from 'src/redux/modules/shoppingCart/shoppingCart.selectors';
import { getModalsSeen } from '../../../../redux/modules/modals/modals.selectors';
import { ExchangeType } from 'src/settings/settings';
import exchangeTypeStyles from '../exchangeType.module.scss';
import AutoExchangeFromFundEditor from '../FromFundEditor';
import styles from './styles.module.scss';
import { isAutoExchangeEdit } from '../../../../utils/transactions-util';

export interface AutoExchangeFromFormProps {
  isSalesforceRep: boolean;
  customerWebViewEnabled: boolean;
  actions;
  modalsSeen;
  exchangeFromFundList: Fund[];
  exchangeType: ExchangeType;
  userFunds: Fund[];
  userFundsList: Fund[];
}

const AutoExchangeFromForm: React.FC<AutoExchangeFromFormProps> = ({
  isSalesforceRep,
  customerWebViewEnabled,
  actions,
  exchangeFromFundList,
  exchangeType,
  userFunds,
  userFundsList,
  modalsSeen,
}) => {
  return (
    <StepExpanded className={styles['container']}>
      <div
        className={classNames(
          exchangeTypeStyles['fund-list'],
          exchangeTypeStyles['single-select']
        )}
      >
        <ExpandedFundList
          {...{ actions, exchangeType, userFunds }}
          IRALimit={{ data: { currentYearRemainingContributions: null } }}
          availableFunds={exchangeFromFundList}
          currentYearInclusiveRemainingContributions={null}
          customerWebViewEnabled={customerWebViewEnabled}
          fundEditor={() => AutoExchangeFromFundEditor}
          isManySelect={false}
          isSalesforceRep={isSalesforceRep}
          modalsSeen={modalsSeen}
          numberOfFunds={userFundsList.length}
          personalData={{}}
          priorYearInclusiveRemainingContributions={null}
          quickBuy={{}}
          shoppingCart={{}}
        />
      </div>
    </StepExpanded>
  );
};

const mapStateToProps = (state) => {
  const {
    exchangeTransaction: { exchangeType },
    userFunds,
  } = state;
  return {
    exchangeFromFundList: isAutoExchangeEdit()
      ? getAutoExchangeFromEditFund(state)
      : getAutoExchangeFromFundList(state),
    exchangeType,
    userFunds,
    userFundsList: getUserFundList(state),
    quickBuyProductType: getQuickBuyProductType(state),
    modalsSeen: getModalsSeen(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  const {
    deselectExchangeFromFund,
    selectExchangeFromFund,
    selectExchangeType,
    updateExchangeFromFundAmount,
    updateExchangeFromFundUnit,
    updateExchangeFund,
  } = exchangeActions;
  return {
    actions: bindActionCreators(
      {
        deselectFund: deselectExchangeFromFund,
        openModal,
        selectExchangeType,
        selectFund: selectExchangeFromFund,
        setShowAllFundsStep,
        updateExchangeFundAmount: updateExchangeFromFundAmount,
        updateExchangeFundUnit: updateExchangeFromFundUnit,
        updateExchangeFund,
      },
      dispatch
    ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AutoExchangeFromForm);
